import { apiGet } from './apiClient';

export type ProductAccessInfo = {
  hasActiveSubscription: boolean;
};

export async function fetchProductAccess(): Promise<ProductAccessInfo> {
  try {
    const payload = await apiGet<ProductAccessInfo>('/me/product-access');
    return { hasActiveSubscription: Boolean(payload?.hasActiveSubscription) };
  } catch (error) {
    console.error('fetchProductAccess error:', error);
    return { hasActiveSubscription: false };
  }
}
